<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-cascades"></i> AI称重系统设置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
            </div>
            <el-table :data="tableData" border class="table" ref="multipleTable">
                <el-table-column prop="beltScaleName" label="皮带秤名称"></el-table-column>
                <el-table-column prop="aiServerIP" label="AI服务器IP"></el-table-column>
                <el-table-column prop="aiServerPort" label="端口"></el-table-column>
                <el-table-column prop="headCorrectionDevName" label="头部纠偏装置"></el-table-column>
                <el-table-column prop="tailCorrectionDevName" label="尾部纠偏装置"></el-table-column>
                <el-table-column label="启用AI系统" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isEnabledAiSys" @change="handleStatusChange(scope.row, 'isEnabledAiSys')"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="启用分析算法" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isAnalysisAlgorithm" @change="handleStatusChange(scope.row, 'isAnalysisAlgorithm')"></el-switch>
                    </template>
                </el-table-column>
                 <el-table-column label="启用AI服务器" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isAiServer" @change="handleStatusChange(scope.row, 'isAiServer')"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="启用头部纠偏" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enableHeadCorrectionDev" @change="handleStatusChange(scope.row, 'enableHeadCorrectionDev')"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="启用尾部纠偏" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.enableTailCorrectionDev" @change="handleStatusChange(scope.row, 'enableTailCorrectionDev')"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                        <el-button type="text" icon="el-icon-delete" class="red" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="30%">
            <el-form ref="form" :model="form" label-width="120px">
                <el-form-item label="皮带秤">
                    <el-select v-model="form.beltScaleId" placeholder="请选择">
                        <el-option v-for="item in balanceArr" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="AI服务器IP">
                    <el-input v-model="form.aiServerIP"></el-input>
                </el-form-item>
                <el-form-item label="端口">
                    <el-input v-model="form.aiServerPort"></el-input>
                </el-form-item>
                <el-form-item label="头部纠偏装置">
                    <el-input v-model="form.headCorrectionDevName"></el-input>
                </el-form-item>
                <el-form-item label="尾部纠偏装置">
                    <el-input v-model="form.tailCorrectionDevName"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'AiWeighingSystemSetup',
    data() {
        return {
            tableData: [],
            balanceArr: [],
            editVisible: false,
            isadd:false,
            form: {},
        };
    },
    created() {
        this.getData();
        this.getBalances();
    },
    methods: {
        getData() {
            this.$zybhttp
                .get('AIWeighing/GetAiWeighingSys', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        this.tableData = res.data.data.list.map(item => {
                            item.isEnabledAiSys = item.isEnabledAiSys == 1;
                            item.isAnalysisAlgorithm = item.isAnalysisAlgorithm == 1;
                            item.isAiServer = item.isAiServer == 1;
                            item.enableHeadCorrectionDev = item.enableHeadCorrectionDev == 1;
                            item.enableTailCorrectionDev = item.enableTailCorrectionDev == 1;
                            return item;
                        });
                    } else {
                        this.$notify.error(res.message);
                    }
                });
        },
        getBalances() {
            this.$zybhttp
                .get('Balance/GetBalance', {
                    params: {
                        balanceId: ''
                    }
                })
                .then((res) => {
                    if (res.data.status == 0) {
                        var d = res.data.data.list;
                        var tem_arr = [];
                        for (let i = 0; i < d.length; i++) {
                            if (d[i].balanceType == 1) {
                                tem_arr[i] = d[i];
                            }
                        }
                        this.balanceArr = tem_arr;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error('网络异常！获取列表失败！'));
        },
        handleAdd() {
            this.isadd = true;
            this.form = {};
            this.editVisible = true;
        },
        handleEdit(index, row) {
            this.isadd = false;
            this.form = Object.assign({}, row);
            this.editVisible = true;
        },
        handleDelete(index, row) {
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp.post('AIWeighing/DelAiWeighingSys', { id: row.id }).then(res => {
                        if (res.data.status == 0) {
                            this.$notify.success('删除成功');
                            this.getData();
                        } else {
                            this.$notify.error('删除失败');
                        }
                    }).catch(err => {
                        this.$notify.error('网络异常！删除失败');
                    });
                })
                .catch(() => {});
        },
        saveEdit() {
            const selectedItem = this.balanceArr.find((item) => item.id === this.form.beltScaleId);
            if(selectedItem){
                this.form.beltScaleName = selectedItem.name;
                this.form.beltScaleGuid = selectedItem.devId;
            }

            let url = this.isadd ? 'AIWeighing/SetAiWeighingSys' : 'AIWeighing/SetAiWeighingSys';
            if(this.isadd){
                // For add, we might not have an ID. The backend should handle it.
                // The original code defaults id to 1 if it's empty. Let's see if that's correct.
                // It seems the logic is more of an "update or create if not exists".
                // Let's stick to a single endpoint for now.
            }

            this.$zybhttp
                .post(url, this.form)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('保存成功');
                        this.editVisible = false;
                        this.getData();
                    } else {
                        this.$notify.error('保存失败');
                    }
                })
                .catch((err) => this.$notify.error('网络异常！保存失败'));
        },
        handleStatusChange(row, field) {
            let updatedRow = Object.assign({}, row);
             this.$zybhttp
                .post('AIWeighing/SetAiWeighingSys', updatedRow)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success('修改成功');
                        this.getData(); // Refresh to ensure consistency
                    } else {
                        this.$notify.error('修改失败');
                        // Revert the switch state on failure for better UX
                        row[field] = !row[field];
                    }
                })
                .catch((err) => {
                    this.$notify.error('网络异常！修改失败');
                    // Revert the switch state on failure
                    row[field] = !row[field];
                });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
</style>
